// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preload {
  overflow: hidden;
}

/* Preload 
  ------------------------------------------- */
.preload-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99999999999;
  display: block;
  overflow: hidden;
}

.preload-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  margin: -100px 0 0 -100px;
  background: #ffffff;
}

.spinner {
  width: 56px;
  max-width: 56px;
  height: 56px;
  display: inline-grid;
  border: 4.5px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  border-color: rgba(20, 160, 118, 0.6392156863) rgba(0, 0, 0, 0);
  animation: spinner-preloader 1s infinite linear;
}

.spinner::before,
.spinner::after {
  content: "";
  grid-area: 1/1;
  margin: 2.2px;
  border: inherit;
  border-radius: 50%;
}

.spinner::before {
  border-color: #921D1E rgba(0, 0, 0, 0);
  animation: inherit;
  animation-duration: 0.5s;
  animation-direction: reverse;
}

.spinner::after {
  margin: 8.9px;
}

@keyframes spinner-preloader {
  100% {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/preloader/style.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;+CAAA;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,+DAAA;EACA,+CAAA;AACJ;;AAEA;;EAEI,WAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEA;EACI,sCAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI;IACI,wBAAA;EACN;AACF","sourcesContent":[".preload {\r\n    overflow: hidden;\r\n}\r\n\r\n/* Preload \r\n  ------------------------------------------- */\r\n.preload-container {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #fff;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 99999999999;\r\n    display: block;\r\n    overflow: hidden;\r\n}\r\n\r\n.preload-logo {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 200px;\r\n    height: 200px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 100;\r\n    margin: -100px 0 0 -100px;\r\n    background: #ffffff;\r\n}\r\n\r\n.spinner {\r\n    width: 56px;\r\n    max-width: 56px;\r\n    height: 56px;\r\n    display: inline-grid;\r\n    border: 4.5px solid #0000;\r\n    border-radius: 50%;\r\n    border-color: #14a076a3 #0000;\r\n    animation: spinner-preloader 1s infinite linear;\r\n}\r\n\r\n.spinner::before,\r\n.spinner::after {\r\n    content: \"\";\r\n    grid-area: 1/1;\r\n    margin: 2.2px;\r\n    border: inherit;\r\n    border-radius: 50%;\r\n}\r\n\r\n.spinner::before {\r\n    border-color: #921D1E #0000;\r\n    animation: inherit;\r\n    animation-duration: 0.5s;\r\n    animation-direction: reverse;\r\n}\r\n\r\n.spinner::after {\r\n    margin: 8.9px;\r\n}\r\n\r\n@keyframes spinner-preloader {\r\n    100% {\r\n        transform: rotate(1turn);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
